import { React ,useState,useEffect } from 'react';
import securityService from './security.service';
import AccessDenied from './access-denied/access-denied';

// Dashboard imports
// import Ecommerce from '../../../dashboard/pages/Ecommerce';
// import { ContextProvider } from '../../../dashboard/contexts/ContextProvider';

// EXPORT MODULE START
import ExportOrderReplicate from '../export/ExportOrderReplicate/ExportOrderReplicate';
import TNAList from '../export/TNA/TNA-list';
import BudgetingList from '../export/Budgeting/Budgeting-list';

// EXPORT MODULE END

// ACCESSORY MODULE START
import AccessoryOpeningList from '../accessory/accessory-opening/accessory-opening-list';
import AccessoryOpeningDetailList from '../accessory/accessory-opening/accessory-opening-detail-list';
// ACCESSORY MODULE END

// SETUP MODULE START
import InvoiceList from '../invoice/invoice-list';
import YarnCountInfoList from '../setup/setup-list';
import YarnQualityInfoList from '../setup/setup-list';
import YarnTypeInfoList from '../setup/setup-list';
import YarnBrandInfoList from '../setup/setup-list';
import FullYarnCountInfoList from '../full-yarn-count-info/full-yarn-count-info-list';
import AccessoryInfoList from '../accessory-info/accessory-info-list';
import BudgetItemInfoList from '../budget-item-info/budget-item-info-list';
import ProductInfoList from '../product-info/product-info-list';

import AccessoryTypeInfoList from '../setup/setup-list';

import CountryInfoList from '../setup/setup-list';
import PortInfoList from '../setup/setup-list';
import CurrencyInfoList from '../setup/setup-list';
import ShipmentTermsInfoList from '../setup/setup-list';
import PackingInfoList from '../setup/setup-list';
import ContractTypeInfoList from '../setup/setup-list';
import ColorInfoList from '../setup/setup-list';
import ProductSizeInfoList from '../setup/setup-list';
import FancyInfoList from '../setup/setup-list';
import UnitInfoList from '../setup/setup-list';
import DeliveryStatusInfoList from '../setup/setup-list';
import GodownInfoList from '../setup/setup-list';
import DesignationInfoList from '../setup/setup-list';
import SoftnessInfoList from '../setup/setup-list';
import DryProcessInfoList from '../setup/setup-list';
import ProcessInfoList from '../setup/setup-list';
import ReProcessInfoList from '../setup/setup-list';
import ProcessDescInfoList from '../setup/setup-list';
import LoomTypeInfoList from '../setup/setup-list';
import SewingTypeInfoList from '../setup/setup-list';

// For Property Project

import PropertyInfoList from '../setup/setup-list';
import PropertyUsageTypeInfoList from '../setup/setup-list';
import BuildingInfoList from '../setup/setup-list';
import PropertyLocationInfoList from '../setup/setup-list';
import PropertyFloorInfoList from '../setup/setup-list';
import PropertyUnitTypeInfoList from '../setup/setup-list';
import CostCenterInfoList from '../setup/setup-list';
import ProductCategoryInfoList from '../setup/setup-list';
import NationalityInfoList from '../setup/setup-list';
import ModeOfPaymentInfoList from '../setup/setup-list';
import VoucherSummaryList from '../voucher/voucher-summary-list';
import VoucherDetailList from '../voucher/voucher-detail-list';
import ReceivableAccountsList from '../setup-inputs/receivable-accounts/receivable-accounts-list'
import AgentAccountsList from '../setup-inputs/agent-accounts/agent-accounts-list'

import UsersInfoList from '../user-info/user-info-list';
import FullPropertyList from '../full-property/full-property-list';
// import ProductList from '../product/product-list';
import PropertyOwnerList from '../property-owner/property-owner-list';
import AdditionalPaymentList from '../additional-payment/additional-payment-list';
import CompanyList from '../company/company-list';
import TenantContractList from '../tenant-contract/tenant-contract-list';
import TenantContractPMList from '../tenant-contract-pm/tenant-contract-pm-list';
import ChequeStatusList from '../cheque-status/cheque-status-list';
import ChangePasswordList from "../change-password/change-password";
import ChangeAccessList from '../security/change-access/change-access';
import SaleInvoiceList from '../sale-invoice/sale-invoice-list';
import PurchaseInvoiceList from '../purchase-invoice/purchase-invoice-list';
import IssueInvoiceList from '../issue-invoice/issue-invoice-list';


import BuyerList from '../buyer/buyer-list';
import ProductDescription1List from '../setup/setup-list';
import ProductDescription2List from '../setup/setup-list';
import ProductDescription3List from '../setup/setup-list';
import ProductDescription4List from '../setup/setup-list';
import ProductDescription5List from '../setup/setup-list';
import ProductDescription6List from '../setup/setup-list';
import GDList from '../setup/setup-list';
import SetupList from '../setup/setup-list';
import ProductList from '../product/product-list';
         
// SETUP MODULE END




import CurrencyTransferList from '../currency-transfer/currency-transfer';
import InvoiceEvaluationList from '../invoice-evaluation/invoice-evaluation';
// import InvoiceSummaryList from '../invoice/invoice-summary';
// import InvoiceDetailList from '../invoice/invoice-detail';
import ShopTransferSummaryList from '../shop-transfer/shop-transfer-summary';
import ShopTransferDetailList from '../shop-transfer/shop-transfer-detail';

import AccountTransferList from '../account-transfer/account-transfer';
import BrandList from '../brand/brand';
import BrandVendorList from '../brand-vendor/brand-vendor';
// import UnitOfMeasurementList from '../unit-of-measurement/unit-of-measurement';
import UnitOfMeasurementList from '../setup/setup-list';
import CurrencyList from '../currency/currency';
import EvaluationRateList from '../evaluation-rate/evaluation-rate';
import ProductTransferList from '../product-transfer/product-transfer';
import ShopList from '../shop/shop';
import SystemLockList from '../system-lock/system-lock';
import DesignationList from '../designation/designation';
import UsersList from '../users/users-list';
import ChartOfAccountList from '../chart-of-account/chart-of-account-list';
// import ExportToExcelList from '../reports/voucher/voucher-xslx';
// import Inventory from '../reports/inventory/inventory';
// import InvoiceCosting from '../reports/invoice-costing/invoice-costing';
// import StockReportValue from '../reports/stock-report-with-value/stock-report-with-value';
// import Voucher from '../reports/voucher/voucher';
import UserReplicateList from "../user-replicate/user-replicate";
// import ChartOfAccountReport from "../reports/chart-of-account/chart-of-account";
// import SendEmailList from "../reports/send-email/send-email";
import TestInputList from "../test-input/test-input-list";
import SellerList from "../seller/seller-list";
import UploadDataByExcelList from '../upload-data-by-excel/upload-data-by-excel-list';
// REPORT MODULE START
// import ExportReport from '../reports/export/report-export';

// REPORT MODULE END

// Add this ABOVE the SecureComponent function
function BuyerWrapper(props) {
    const [view, setView] = useState(null);

    useEffect(() => {
        if (window?.location?.pathname?.split('/')[1] === 'Buyer') {
            setView('buyer');
        } else {
            securityService.getShowPurchaseChallan().then(ok => {
                setView(ok === true ? 'vendor' : 'denied');
            });
        }
    }, []);

    if (view === null) return null; // or a loading spinner

    if (view === 'buyer')  return <BuyerList Active={false} {...props} />;
    if (view === 'vendor') return <BuyerList Active={false} BusinessType='Vendor' {...props} />;
    return <AccessDenied {...props} />;
}

function TrueRouteWrapper(props) {
    const [view, setView] = useState(null);

    useEffect(() => {
        const path = window?.location?.pathname?.toLowerCase() || '';
        const segments = path.split('/');
        const seg1 = segments[1] || ''; // /Vendor
        const seg2 = segments[2] || ''; // /setup/SaleInvoice

        console.log('seg1:', seg1, 'seg2:', seg2);
        // if (seg1 == 'setup') {
        //     setView('setup')
        // }
         if (seg2 == 'saleinvoice' || seg2 == 'unitofmeasurement') {
            securityService.getShowSaleChallan().then(ok => {
                if (ok === true) {
                    if (seg2 == 'saleinvoice')       setView('saleinvoice');
                    if (seg2 == 'unitofmeasurement') setView('unitofmeasurement');
                } else {
                    setView('denied');
                }
            });
        } 
        else if (seg2 == 'purchaseinvoice' || seg1 == 'vendor'
        || seg2 == 'productdescription1' || seg2 == 'productdescription2' || seg2 == 'productdescription3'
        || seg2 == 'productdescription4' || seg2 == 'productdescription5' || seg2 == 'productdescription6'
        || seg2 == 'gd' || seg2 == 'product') {
            securityService.getShowPurchaseChallan().then(ok => {
                if (ok === true) {
                    if (seg2 == 'purchaseinvoice') setView('purchaseinvoice');
                    if (seg1 == 'vendor')          setView('vendor');
                    if (seg2 == 'productdescription1')          setView('productdescription1');
                    if (seg2 == 'productdescription2')          setView('productdescription2');
                    if (seg2 == 'productdescription3')          setView('productdescription3');
                    if (seg2 == 'productdescription4')          setView('productdescription4');
                    if (seg2 == 'productdescription5')          setView('productdescription5');
                    if (seg2 == 'productdescription6')          setView('productdescription6');
                    if (seg2 == 'gd')          setView('gd');
                    if (seg2 == 'product')          setView('product');

                } else {
                    setView('denied');
                }
            });
        } 
        else {
            setView('denied');
        }
    }, []);

    if (view === null) return null;

    // ✅ یہ typo بھی fix کیا - 'salenvoice' تھا
    if (view === 'saleinvoice')                    return <InvoiceList {...props} InvoiceType='SS' Title='SALE INVOICE' />              
    if (view === 'purchaseinvoice')                return <InvoiceList {...props} InvoiceType='PP' Title='PURCHASE INVOICE' /> 
    if (view === 'unitofmeasurement')              return <UnitOfMeasurementList {...props} />;
    if (view === 'vendor')                         return <BuyerList Active={false} BusinessType='Vendor' {...props} />;
    if (view === 'setup')                          return <SetupList  {...props} />;
    if (view === 'productdescription1')            return <ProductDescription1List  {...props} />;
    if (view === 'productdescription2')            return <ProductDescription2List  {...props} />;
    if (view === 'productdescription3')            return <ProductDescription3List  {...props} />;
    if (view === 'productdescription4')            return <ProductDescription4List  {...props} />;
    if (view === 'productdescription5')            return <ProductDescription5List  {...props} />;
    if (view === 'productdescription6')            return <ProductDescription6List  {...props} />;
    if (view === 'gd')                             return <GDList  {...props} />;
    if (view === 'product')                             return <ProductList  {...props} />;
    
    return <AccessDenied {...props} />;
}
export default function SecureComponent(props) {
    if (props.name === true || props.name === 'true') {
        console.log(props);
        return <TrueRouteWrapper {...props} />;
    }
    const canUserAccess = props.name ==  true ? true : securityService.canUserAccess(props.name)['List'];
    if (!canUserAccess) {
        // return <AccessDenied {...props} />

        switch (props.name) {
            case 'SaleInvoice':
                    return <InvoiceList {...props} InvoiceType='SS' Title='SALE INVOICE' /> 
            case 'PurchaseInvoice':
                    return <InvoiceList {...props} InvoiceType='PP' Title='PURCHASE INVOICE' /> 
            case 'ChangePasswordList':
                    return <ChangePasswordList {...props} /> 
            case 'ChangeAccessList':
                return <ChangeAccessList {...props} /> 
                case 'ReceivableAccountsList':
                    return <ReceivableAccountsList {...props} /> 
                    case 'AgentAccountsList':

                    return <AgentAccountsList {...props} /> 
                    case 'ChartOfAccountList':
                        return <ChartOfAccountList {...props} /> 
                    
                
                // case 'InvoiceCosting':
                //     return <InvoiceCosting {...props} /> 
                // case 'StockWithOutValue':
                //     return <StockReportValue {...props} /> 
                // case 'StockWithValue':
                //     return <StockReportValue {...props} /> 
                // case 'CashPaymentPreview':
                //     return <Voucher {...props} /> 
                // case 'CashReceiptPreview':
                //     return <Voucher {...props} /> 
                // case 'JournalVoucherPreview':
                //     return <Voucher {...props} /> 
            // case 'ExportToExcelList':
            //     return <ExportToExcelList {...props} />
            case 'BrandVendorList':
                    return <BrandVendorList {...props} />
                   
                    // case 'ChartOfAccountReport':
                    //     return <ChartOfAccountReport  {...props}/>
                    // case 'SendEmailList':
                    //     return <SendEmailList  {...props}/>
                    case 'TestInputList':
                        return <TestInputList  {...props}/>    
                        case 'SaleInvoice':
                            return <InvoiceList {...props} InvoiceType='SS' Title='SALE INVOICE' />              
                        case 'PurchaseInvoice':
                            return <InvoiceList {...props} InvoiceType='PP' Title='PURCHASE INVOICE' />              
                        
                            case 'Vender':
                                return <BuyerWrapper {...props} />;

                            case 'import data':
                    return <UploadDataByExcelList  {...props} />
                            case 'UOM':
                    return <UploadDataByExcelList  {...props} />
                    case 'Unit Of Measurement':
                        return <UnitOfMeasurementList {...props} />
                default:
                return <AccessDenied {...props} />
            break;
    }
    }
    else {
        switch (props.name) {
            case 'User Information':
                return <UsersInfoList Active={false} {...props} />
                case 'Full Property':
                return <FullPropertyList Active={false} {...props} />
                // case 'Product':
                // return <ProductList Active={false} {...props} />
                case 'Property Owner':
                return <PropertyOwnerList Active={false} {...props} />
                case 'Additional Payment':
                    return <AdditionalPaymentList Active={false} {...props} />
                case 'Company':
                return <CompanyList Active={false} {...props} />
                case 'Tenant Contract FS':
                    return <TenantContractList Active={false} {...props} />
                    case 'Tenant Contract PM':
                        return <TenantContractPMList Active={false} {...props} />    
                    case 'Cheque Status':
                    return <ChequeStatusList Active={false} {...props} />
                case 'Sale Invoice':
                    return <SaleInvoiceList Active={false} {...props} /> 
                case 'Sale Invoice Sandbox':
                    return <SaleInvoiceList Active={false} {...props} /> 
                // case 'Sale Invoice':
                //     return <SaleInvoiceList Active={false} {...props} /> 
                case 'Purchase Invoice':
                    return <PurchaseInvoiceList Active={false} {...props} />
                case 'Issue Invoice':
                    return <IssueInvoiceList Active={false} {...props} />                   
                // if(props.path == '/UsersInfo/Active'){
                //     return <UsersInfoList Active={true} {...props} />
                // }else if(props.path  == '/UsersInfo/InActive'){
                //     return <UsersInfoList Active={false} {...props} />
                // }

                // case 'Dashboard':
                //     return (
                //         <ContextProvider>
                //             <Ecommerce {...props} />
                //         </ContextProvider>
                //     );
                
                case 'Export Order - Replicate':
                    return <ExportOrderReplicate {...props} />
                case 'TNA':
                    return <TNAList {...props} />
                case 'Budgeting':
                    return <BudgetingList {...props} />
                case 'Yarn Count':
                    return <YarnCountInfoList {...props} />
                case 'Yarn Quality':
                    return <YarnQualityInfoList {...props} />
                case 'Yarn Type':
                    return <YarnTypeInfoList {...props} />
                case 'Yarn Brand':
                    return <YarnBrandInfoList {...props} />
                case 'Full Yarn Count':
                    return <FullYarnCountInfoList {...props} />
                case 'Accessory':
                    return <AccessoryInfoList {...props} />
                case 'Budget Items':
                    return <BudgetItemInfoList {...props} />
                case 'Product':
                    return <ProductInfoList {...props} />
                
                case 'Accessory Type':
                    return <AccessoryTypeInfoList {...props} />


                case 'Country':
                    return <CountryInfoList {...props} />
                case 'Port':
                    return <PortInfoList {...props} />
                case 'Currency':
                    return <CurrencyInfoList {...props} />
                case 'Shipment Terms':
                    return <ShipmentTermsInfoList {...props} />
                case 'Packing':
                    return <PackingInfoList {...props} />
                case 'Contract Type':
                    return <ContractTypeInfoList {...props} />
                case 'Color':
                    return <ColorInfoList {...props} />
                case 'Product Size':
                    return <ProductSizeInfoList {...props} />
                case 'Fancy':
                    return <FancyInfoList {...props} />
                case 'Unit':
                    return <UnitInfoList {...props} />
                case 'Delivery Status':
                    return <DeliveryStatusInfoList {...props} />
                case 'Godown':
                    return <GodownInfoList {...props} />
                case 'Designation':
                    return <DesignationInfoList {...props} />
                case 'Softness':
                    return <SoftnessInfoList {...props} />
                case 'Dry Process':
                    return <DryProcessInfoList {...props} />
                case 'Process':
                    return <ProcessInfoList {...props} />
                case 'ReProcess':
                    return <ReProcessInfoList {...props} />
                case 'Process Description':
                    return <ProcessDescInfoList {...props} />
                case 'Loom Type':
                    return <LoomTypeInfoList {...props} />
                case 'Sewing Type':
                    return <SewingTypeInfoList {...props} />
    
// For Property Project

                case 'Property':
                return <PropertyInfoList {...props} />;
                case 'Property Usage Type':
                return <PropertyUsageTypeInfoList {...props} />;
                case 'Building':
                return <BuildingInfoList {...props} />;
                case 'Property Location':
                return <PropertyLocationInfoList {...props} />;
                case 'Property Floor':
                return <PropertyFloorInfoList {...props} />;
                case 'Property Unit Type':
                return <PropertyUnitTypeInfoList {...props} />;
                case 'Cost Center':
                return <CostCenterInfoList {...props} />;
                case 'Product Category':
                return <ProductCategoryInfoList {...props} />;
                case 'Nationality':
                return <NationalityInfoList {...props} />;
                case 'Mode Of Payment':
                return <ModeOfPaymentInfoList {...props} />;

                case 'Receipt Voucher':
                    if(window?.location?.pathname?.split('/')[3] == 'Summary'){
                        return <VoucherSummaryList ListType={window.location.pathname.split('/')[3]} Type={window.location.pathname.split('/')[2]} {...props} />
                    }else{
                        return <VoucherDetailList ListType={window.location.pathname.split('/')[3]} Type={window.location.pathname.split('/')[2]} {...props} />
                    }  
                    // return <VoucherList {...props} />
                case 'Payment Voucher':
                    if(window?.location?.pathname?.split('/')[3] == 'Summary'){
                        return <VoucherSummaryList ListType={window.location.pathname.split('/')[3]} Type={window.location.pathname.split('/')[2]} {...props} />
                    }else{
                        return <VoucherDetailList ListType={window.location.pathname.split('/')[3]} Type={window.location.pathname.split('/')[2]} {...props} />
                    }  
                    // return <VoucherList {...props} />
                case 'Journal Voucher':
                    console.log(window?.location?.pathname?.split('/'))
    
                    if(window?.location?.pathname?.split('/')[3] == 'Summary'){
                        return <VoucherSummaryList ListType={window.location.pathname.split('/')[3]} Type={window.location.pathname.split('/')[2]} {...props} />
                    }else{
                        return <VoucherDetailList ListType={window.location.pathname.split('/')[3]} Type={window.location.pathname.split('/')[2]} {...props} />
                    }


            case 'CurrencyTransferList':
                return <CurrencyTransferList {...props} />
            // case 'InvoiceEvaluationList':
            //     return <InvoiceEvaluationList {...props} />
            // case 'PurchaseInvoiceList':
            //     if(props.location.pathname.split('/')[3] == 'Summary'){
            //         return <InvoiceSummaryList {...props} />
            //     }else{
            //         return <InvoiceDetailList {...props} />
            //     }
            // case 'SaleInvoiceList':
            //     if(props.location.pathname.split('/')[3] == 'Summary'){
            //         return <InvoiceSummaryList {...props} />
            //     }else{
            //         return <InvoiceDetailList {...props} />
            //     }
            case 'ShopTransferList':
                if(props.location.pathname.split('/')[2] == 'Summary'){
                    return <ShopTransferSummaryList {...props} />
                }else{
                    return <ShopTransferDetailList {...props} />
                }    
            // return <ShopTransferList {...props} />
            // case 'ReceiptVoucherList':
            //     if(props.location.pathname.split('/')[3] == 'Summary'){
            //         return <VoucherSummaryList {...props} />
            //     }else{
            //         return <VoucherDetailList {...props} />
            //     }  
            //     // return <VoucherList {...props} />
            // case 'PaymentVoucherList':
            //     if(props.location.pathname.split('/')[3] == 'Summary'){
            //         return <VoucherSummaryList {...props} />
            //     }else{
            //         return <VoucherDetailList {...props} />
            //     }  
            //     // return <VoucherList {...props} />
            // case 'JournalVoucherList':
            //     if(props.location.pathname.split('/')[3] == 'Summary'){
            //         return <VoucherSummaryList {...props} />
            //     }else{
            //         return <VoucherDetailList {...props} />
            //     } 
            case 'AccountTransferList':
                return <AccountTransferList {...props} />
            case 'BrandList':
                return <BrandList {...props} />
            case 'BrandVendorList':
                return <BrandVendorList {...props} />
            case 'Unit Of Measurement':
                return <UnitOfMeasurementList {...props} />
            case 'CurrencyList':
                return <CurrencyList {...props} />
            case 'EvaluationRateList':
                return <EvaluationRateList {...props} />
            case 'ProductTransferList':
                return <ProductTransferList {...props} />
            case 'ShopList':
                return <ShopList {...props} />
            case 'SystemLockList':
                return <SystemLockList {...props} />
                case 'ChangePasswordList':
                    return <ChangePasswordList {...props}/>
                    case 'DesignationList':
                    return <DesignationList {...props} />
                case 'UsersList':
                    return <UsersList {...props} />
                
                    case 'UserReplicateList':
                        return <UserReplicateList  {...props}/>

            // case 'Reports - Export':
            //     return <ExportReport  {...props}/>

            case 'Accessory Opening':
                if(props.location.pathname.split('/')[3] == 'Summary'){
                    return <AccessoryOpeningList {...props} />
                }else{
                    return <AccessoryOpeningDetailList {...props} />
                } 
                case 'Seller':
                    return <SellerList {...props} InvoiceType='SS' Title='SALE INVOICE' />              
                case 'Buyer':
                    return <BuyerWrapper {...props} />;

                    case 'ProductDescription1':
                        return <ProductDescription1List {...props} />;
                    case 'ProductDescription2':
                        return <ProductDescription2List {...props} />;
                    case 'ProductDescription3':
                        return <ProductDescription3List {...props} />;
                    case 'ProductDescription4':
                        return <ProductDescription4List {...props} />;
                    case 'ProductDescription5':
                        return <ProductDescription5List {...props} />;
                    case 'ProductDescription6':
                        return <ProductDescription6List {...props} />;
                    case 'GD':
                        return <GDList {...props} />;
                    default:
                          return <AccessDenied {...props} />;
                    
                
            break;
        }
    }
}
